var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _c(
        "div",
        { staticClass: "box" },
        [
          _c("h1", { staticClass: "subtitle is-4" }, [
            _vm._v("Mis certificados"),
          ]),
          _vm._v(" "),
          _c("h1", { staticClass: "title is-3" }, [_vm._v("Certificado")]),
          _vm._v(" "),
          _vm._l(_vm.filteredCerts, function (cert, index) {
            return _c(
              "div",
              { key: index },
              [
                cert.estado === "vigente" && cert.por_vencer
                  ? _c(
                      "b-tag",
                      {
                        staticClass: "mb-3",
                        attrs: { type: "is-warning", size: "is-medium" },
                      },
                      [
                        _vm._v(
                          "\n        ¡El certificado está por expirar!\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                cert.estado === "pendiente"
                  ? _c("p", { staticClass: "is-400 is-italic" }, [
                      _vm._v("\n        Pendiente de revisión\n      "),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                cert.estado === "pendiente"
                  ? _c("p", { staticClass: "mt-1" }, [
                      _vm._v(
                        "\n        Esperando que un Administrador de Certificados confirme que firmó el acuerdo de suscriptores.\n      "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                cert.estado === "preaprobado"
                  ? _c("p", { staticClass: "is-400 is-italic" }, [
                      _vm._v(
                        "\n        Se confirmó que entregó y firmó el acuerdo de suscriptores en tiempo y forma\n      "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                cert.estado === "preaprobado"
                  ? _c("p", { staticClass: "mt-1" }, [
                      _vm._v(
                        "\n        Esperando que un Oficial de Registro autorice la emisión del certificado.\n      "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                cert.estado === "vigente"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "is-flex is-flex-direction-row is-align-items-center pb-4",
                      },
                      [
                        cert.estado === "vigente" && cert.por_vencer
                          ? _c(
                              "router-link",
                              {
                                staticClass:
                                  "button is-success is-outlined mr-4",
                                attrs: {
                                  to: {
                                    name: "certificadosRenovacion",
                                    params: { idCert: cert.id },
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "fas fa-redo" }),
                                _vm._v("  Renovar\n        "),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        cert.estado === "vigente"
                          ? _c(
                              "router-link",
                              {
                                staticClass:
                                  "button is-danger is-outlined mr-4",
                                attrs: {
                                  to: {
                                    name: "certificadosRevocacion",
                                    params: { idCert: cert.id },
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "fas fa-times" }),
                                _vm._v("  Revocar\n        "),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _c("div", { staticClass: "py-1" }),
                _vm._v(" "),
                _c("div", { staticClass: "is-flex is-flex-direction-column" }, [
                  cert.estado !== "vigente"
                    ? _c("span", [
                        _c("span", { staticClass: "is-500" }, [
                          _vm._v("Fecha de solicitud:"),
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.dateFormat(cert.created_at)) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  cert.estado !== "pendiente" && cert.estado !== "preaprobado"
                    ? _c("span", [
                        _c("span", { staticClass: "is-500" }, [
                          _vm._v("Fecha de emisión:"),
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.dateFormat(cert.fecha_emision)) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  cert.estado !== "pendiente" && cert.estado !== "preaprobado"
                    ? _c("span", { staticClass: "my-1" }, [
                        _c("span", { staticClass: "is-500" }, [
                          _vm._v("Fecha de vencimiento:"),
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.dateFormat(cert.fecha_vencimiento)) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  cert.estado !== "pendiente" && cert.estado !== "preaprobado"
                    ? _c("span", { staticClass: "is-size-6 is-400" }, [
                        _c("span", { staticClass: "is-500" }, [
                          _vm._v("Número de serie:"),
                        ]),
                        _vm._v(" " + _vm._s(cert.numero_serie) + "\n        "),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm.filteredCerts.length > 1 ? _c("hr") : _vm._e(),
              ],
              1
            )
          }),
          _vm._v(" "),
          !_vm.filteredCerts.length > 0
            ? _c(
                "h1",
                { staticClass: "mt-1 subtitle is-5 has-text-black" },
                [
                  _vm._v(
                    "\n      No posee un certificado vigente, puede generar uno\n      "
                  ),
                  _c(
                    "router-link",
                    { attrs: { to: { name: "certificadosNuevaSolicitud" } } },
                    [_vm._v("haciendo click aquí")]
                  ),
                  _vm._v(".\n    "),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "box mb-4" }, [
        _c("h1", { staticClass: "subtitle is-5 mb-4" }, [_vm._v("Registro")]),
        _vm._v(" "),
        _c("div", { staticClass: "p-2" }, [
          _c(
            "div",
            {
              staticClass:
                "is-flex is-flex-direction-row is-align-items-center mb-2",
            },
            [
              _c("span", { staticClass: "has-text-primary is-500 mr-4" }, [
                _vm._v("Filtros"),
              ]),
              _vm._v(" "),
              _c(
                "b-dropdown",
                {
                  attrs: { multiple: "", "aria-role": "list" },
                  scopedSlots: _vm._u([
                    {
                      key: "trigger",
                      fn: function () {
                        return [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                type: "is-white",
                                "icon-right": "caret-down",
                              },
                            },
                            [
                              _vm._v(
                                "\n              Estado (" +
                                  _vm._s(_vm.selectedLabels.length) +
                                  ")\n            "
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.selectedLabels,
                    callback: function ($$v) {
                      _vm.selectedLabels = $$v
                    },
                    expression: "selectedLabels",
                  },
                },
                [
                  _vm._v(" "),
                  _vm._l(_vm.availableLabels, function (label, i) {
                    return _c(
                      "b-dropdown-item",
                      {
                        key: `label-${i}`,
                        attrs: { value: label, "aria-role": "listitem" },
                        on: { click: _vm.filterCerts },
                      },
                      [_c("span", [_vm._v(_vm._s(label))])]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c("b-button", {
                staticClass: "is-primary ml-auto",
                attrs: { "icon-right": "fas fa-sync" },
                on: { click: _vm.emptyFilters },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.selectedLabels.length
            ? _c("span", [
                _c("span", { staticClass: "is-500 is-italic" }, [
                  _vm._v("Seleccionados: "),
                ]),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.selectedLabels.join(", ")) +
                    "\n      "
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm.isLoading
        ? _c(
            "div",
            { staticClass: "box has-text-centered" },
            [_c("loading-spin")],
            1
          )
        : _vm._l(_vm.certList, function (cert, index) {
            return _c("div", { key: index, staticClass: "box mb-4" }, [
              cert.estado === "pre-pendiente"
                ? _c(
                    "section",
                    {
                      staticClass:
                        "is-flex is-flex-direction-row is-align-items-center is-justify-content-center pb-4",
                    },
                    [
                      _c("b-message", { attrs: { type: "is-danger" } }, [
                        _vm._v(
                          "\n          Este certificado se encuentra en un estado incompleto. Por favor, comunicarse con un administrador de Lyris IT para resolver el problema.\n      "
                        ),
                      ]),
                    ],
                    1
                  )
                : _c("section", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "is-flex is-flex-direction-row is-align-items-center",
                      },
                      [
                        _c("div", { staticClass: "is-flex-grow-1" }, [
                          cert.estado === "pendiente"
                            ? _c("span", { staticClass: "is-400 is-italic" }, [
                                _vm._v(
                                  "\n            Pendiente de revisión\n          "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          cert.estado === "preaprobado"
                            ? _c("span", { staticClass: "is-400 is-italic" }, [
                                _vm._v(
                                  "\n            Se confirmó que entregó y firmó el acuerdo de suscriptores en tiempo y forma\n          "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          cert.estado === "rechazado"
                            ? _c("span", { staticClass: "is-400 is-italic" }, [
                                _vm._v(
                                  "\n            Solicitud rechazada\n          "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          cert.estado !== "pendiente" &&
                          cert.estado !== "rechazado" &&
                          cert.estado !== "preaprobado"
                            ? _c("span", { staticClass: "is-size-6 is-400" }, [
                                _c(
                                  "span",
                                  { staticClass: "is-size-6 is-500" },
                                  [_vm._v("Número de serie:")]
                                ),
                                _vm._v(
                                  " " +
                                    _vm._s(cert.numero_serie) +
                                    "\n          "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        cert.estado === "pendiente"
                          ? _c(
                              "b-tag",
                              {
                                staticClass: "is-500",
                                attrs: {
                                  rounded: "",
                                  type: "is-warning is-light",
                                  size: "is-medium",
                                },
                              },
                              [_vm._v("Pendiente")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        cert.estado === "preaprobado"
                          ? _c(
                              "b-tag",
                              {
                                staticClass: "is-500",
                                attrs: {
                                  rounded: "",
                                  type: "is-info is-light",
                                  size: "is-medium",
                                },
                              },
                              [_vm._v("Preaprobado")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        cert.estado === "vigente"
                          ? _c(
                              "b-tag",
                              {
                                staticClass: "is-500",
                                attrs: {
                                  rounded: "",
                                  type: "is-success is-light",
                                  size: "is-medium",
                                },
                              },
                              [_vm._v("Vigente")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        cert.estado === "revocado"
                          ? _c(
                              "b-tag",
                              {
                                staticClass: "is-500",
                                attrs: {
                                  rounded: "",
                                  type: "is-danger is-light",
                                  size: "is-medium",
                                },
                              },
                              [_vm._v("Revocado")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        cert.estado === "rechazado"
                          ? _c(
                              "b-tag",
                              {
                                staticClass: "is-500",
                                attrs: {
                                  rounded: "",
                                  type: "is-danger is-light",
                                  size: "is-medium",
                                },
                              },
                              [_vm._v("Rechazado")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        cert.estado === "vencido"
                          ? _c(
                              "b-tag",
                              {
                                staticClass: "is-500",
                                attrs: {
                                  rounded: "",
                                  type: "is-light",
                                  size: "is-medium",
                                },
                              },
                              [_vm._v("Vencido")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "is-flex is-flex-direction-column py-1" },
                      [
                        cert.estado === "pendiente" ||
                        cert.estado === "rechazado" ||
                        cert.estado === "preaprobado"
                          ? _c("span", [
                              _c("span", { staticClass: "is-500" }, [
                                _vm._v("Fecha de solicitud:"),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.dateFormat(cert.created_at)) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        cert.estado !== "pendiente" &&
                        cert.estado !== "rechazado" &&
                        cert.estado !== "preaprobado"
                          ? _c("span", [
                              _c("span", { staticClass: "is-500" }, [
                                _vm._v("Fecha de emisión:"),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.dateFormat(cert.fecha_emision)) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        cert.estado !== "pendiente" &&
                        cert.estado !== "rechazado" &&
                        cert.estado !== "preaprobado"
                          ? _c("span", { staticClass: "mt-1" }, [
                              _c("span", { staticClass: "is-500" }, [
                                _vm._v("Fecha de vencimiento:"),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.dateFormat(cert.fecha_vencimiento)
                                  ) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        cert.estado === "revocado"
                          ? _c("span", { staticClass: "mt-1" }, [
                              _c("span", { staticClass: "is-500" }, [
                                _vm._v("Fecha de revocación:"),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.dateFormat(cert.fecha_revocacion)
                                  ) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]),
            ])
          }),
      _vm._v(" "),
      _vm.certList.length === 0 && !_vm.isLoading
        ? _c("div", { staticClass: "box has-text-centered" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      _c("paginator", {
        ref: "paginator",
        attrs: { resource: _vm.url, loading: _vm.isLoading },
        on: {
          update: _vm.updateResource,
          "update:loading": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", { staticClass: "section is-mono" }, [
      _c("span", { staticClass: "tag is-rounded is-medium" }, [
        _c("i", { staticClass: "fas fa-info fa-fw" }),
        _vm._v(" Sin certificados para mostrar\n      "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }